export default "__VITE_ASSET__BWhQEZc6__"